import { render, staticRenderFns } from "./ProTag.vue?vue&type=template&id=4fd2ccc3&scoped=true&"
import script from "./ProTag.vue?vue&type=script&lang=js&"
export * from "./ProTag.vue?vue&type=script&lang=js&"
import style0 from "./ProTag.vue?vue&type=style&index=0&id=4fd2ccc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd2ccc3",
  null
  
)

component.options.__file = "ProTag.vue"
export default component.exports